module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-nytimes-1280.d2cb8d48a4599909.png"+" 1280w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-nytimes-1280.d2cb8d48a4599909.png",width: 1280,height: 216}],
        src: "https://static.sniffspot.com/packs/img/p-nytimes-1280.d2cb8d48a4599909.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-nytimes-1280.d2cb8d48a4599909.png"},
        
        width: 1280,
        height: 216
      }